import '@mantine/core/styles.css';
import "./index.css";
import {SimpleGrid, Text} from "@mantine/core";
import {useState} from "react";
import type {ExerciseType} from "./exercise_info.tsx";
import {Link} from "react-router";
import {CustomCard} from "./card.tsx";

export function Home() {
  const [selected, setSelected] = useState<undefined | ExerciseType>()

  if (selected) {
    return selected
  }

  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
      <ExerciseOptionCard
        label="Upper body push"
        image="https://static.strengthlevel.com/images/exercises/dumbbell-bench-press/dumbbell-bench-press-400.avif"
        subtext="Dumbbell bench, shoulder press, lateral raises, tricep extensions, etc."
        href="/push"
      />
      <ExerciseOptionCard
        label="Lower body + core"
        image="https://static.strengthlevel.com/images/exercises/goblet-squat/goblet-squat-400.avif"
        subtext="Goblet squats, dumbbell lunges, russian twists, etc."
        href="/core"
      />
      <ExerciseOptionCard
        label="Upper body pull"
        image="https://static.strengthlevel.com/images/exercises/dumbbell-curl/dumbbell-curl-400.avif"
        subtext="Dumbell rows, reverse flys, curls, renegade rows, etc."
        href="/pull"
      />
    </SimpleGrid>
  );
}

interface ExerciseOptionCardProps {
  label: string
  image: string
  subtext: string
  href: `/${ExerciseType}`
}
function ExerciseOptionCard({label, image, subtext, href}: ExerciseOptionCardProps) {
  return (
    <Link to={href} style={{ textDecoration: 'none' }}>
      <CustomCard label={label} image={image}>
        <Text mt="xs" c="dimmed" size="sm">
          {subtext}
        </Text>
      </CustomCard>
    </Link>
  )
}
